import { SEMAPHORE_COLORS } from './semaphore-base';

export const CREDIT_LINE_EXTERNAL_STATUS = {
  LINE_ACTIVE_WITH_QUOTA: 'LINE_ACTIVE_WITH_QUOTA',
  LINE_ACTIVE_WITHOUT_QUOTA: 'LINE_ACTIVE_WITHOUT_QUOTA',
  LINE_NOT_AVAILABLE: 'LINE_NOT_AVAILABLE',
  PENDING: 'PENDING',
};

export const CREDIT_LINE_EXTERNAL_STATUS_TEXT = {
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_ACTIVE_WITH_QUOTA]: 'Vigente Con Cupo',
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_ACTIVE_WITHOUT_QUOTA]: 'Vigente Sin Cupo',
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_NOT_AVAILABLE]: 'Vencida o Inexistente',
  [CREDIT_LINE_EXTERNAL_STATUS.PENDING]: 'Pendiente',
};

export const CREDIT_LINE_EXTERNAL_STATUS_COLORS = {
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_ACTIVE_WITH_QUOTA]: SEMAPHORE_COLORS.green,
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_ACTIVE_WITHOUT_QUOTA]: SEMAPHORE_COLORS.yellow,
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_NOT_AVAILABLE]: SEMAPHORE_COLORS.red,
  [CREDIT_LINE_EXTERNAL_STATUS.PENDING]: SEMAPHORE_COLORS.pending,
};

export const ITAU_CREDIT_LINE_EXTERNAL_STATUS_TEXT = {
  ...CREDIT_LINE_EXTERNAL_STATUS_TEXT,
  [CREDIT_LINE_EXTERNAL_STATUS.LINE_NOT_AVAILABLE]: 'No Disponible',
};
